import React, { PropTypes } from 'react';
import ManagerEditForm from '../ManagerEditForm';

class ManagersEdit extends React.Component {
  static propTypes = {
    params: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    fetch: PropTypes.func.isRequired
  };

  state = {
    loading: true
  };

  componentWillMount() {
    let { id } = this.props.params;
    this.props.fetch(id);
  }

  componentWillReceiveProps(nextProps) {
    let { loading } = nextProps;
    this.setState({loading: this.state.loading && loading});
  }

  render() {
    let { loading } = this.state;

    return (
      <div>
        {!loading
          ? (<ManagerEditForm {...this.props}/>)
          : (<div>Loading</div>)
        }
      </div>
    );
  }
}

export default ManagersEdit;



// WEBPACK FOOTER //
// ./src/components/Managers/ManagersEdit/component.jsx